import { render, staticRenderFns } from "./PaletaColoresModal.vue?vue&type=template&id=7fdd2b06"
import script from "./PaletaColoresModal.vue?vue&type=script&lang=js"
export * from "./PaletaColoresModal.vue?vue&type=script&lang=js"
import style0 from "./PaletaColoresModal.vue?vue&type=style&index=0&id=7fdd2b06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports